import { useState } from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import { PLANS_DATA, FAQ_DATA } from '../data';
import './Membership.css';

export default function Membership({ setPage }) {
  const ref = useScrollReveal();
  const [faqOpen, setFaqOpen] = useState(null);

  const go = (p) => {
    setPage(p);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const compareRows = [
    ['Full Gym Access', '✓', '✓', '✓'],
    ['Group Classes', '3 / mo', 'Unlimited', 'Unlimited'],
    ['Personal Training', '—', '2 / mo', '6 / mo'],
    ['Nutrition Coaching', '—', 'Basic', 'Full'],
    ['Recovery Zone', '—', '—', '✓'],
    ['Guest Passes', '—', '2 / mo', 'Unlimited'],
    ['Body Analysis', '1 / yr', '2 / yr', 'Monthly'],
    ['App Analytics', 'Basic', 'Advanced', 'Elite'],
  ];

  return (
    <div ref={ref}>
      {/* HERO */}
      <div className="page-hero">
        <div className="mem-hero-bg" />
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <div className="sec-eyebrow fade-up">Flexible Pricing</div>
          <h1 className="page-title-xl fade-up delay-1">
            MEMBERSHIP <span className="acc">PLANS</span>
          </h1>
        </div>
      </div>

      {/* PLANS */}
      <section className="section membership-plans-section">
        <div className="section-inner">
          <div className="text-center fade-up membership-head">
            <h2 className="sec-title">
              CHOOSE YOUR <span className="acc">LEVEL</span>
            </h2>
            <div className="divider center" />
            <p className="sec-desc membership-desc">
              Choose the membership that fits your routine, your goals, and your
              budget. Every plan is designed to give you the right support to keep
              progressing.
            </p>
          </div>

          <div className="plans-row fade-up delay-2">
            {PLANS_DATA.map((p) => (
              <div className={`plan${p.featured ? ' gold-plan' : ''}`} key={p.name}>
                {p.featured && <div className="plan-ribbon">Most Popular</div>}

                <div
                  className="plan-tier"
                  style={{ marginTop: p.featured ? '2rem' : '0' }}
                >
                  {p.tier}
                </div>

                <div className="plan-name">{p.name}</div>

                <div className="plan-price-row">
                  <span className="plan-curr">₹</span>
                  <span className="plan-amt">{p.price}</span>
                  <span className="plan-per"></span>
                </div>

                <ul className="plan-features">
                  {p.features.map((f, j) => (
                    <li key={j} className={!f.ok ? 'disabled-feature' : ''}>
                      <span className={f.ok ? 'tick' : 'cross'}>
                        {f.ok ? '✓' : '✗'}
                      </span>
                      <span>{f.label}</span>
                    </li>
                  ))}
                </ul>

                <button
                  className={p.featured ? 'btn-primary' : 'btn-ghost'}
                  style={{ width: '100%', justifyContent: 'center', marginTop: 'auto' }}
                  onClick={() => go('Contact')}
                >
                  Get Started →
                </button>
              </div>
            ))}
          </div>

          {/* COMPARE TABLE */}
          <div className="compare-wrap fade-up">
            <h3 className="compare-heading">Full Feature Comparison</h3>

            <div className="compare-table-wrap">
              <table className="compare-table">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left' }}>Feature</th>
                    <th>Monthly Plan</th>
                    <th className="featured-col">Quarterly Plan</th>
                    <th>Half-Yearly Plan</th>
                  </tr>
                </thead>
                <tbody>
                  {compareRows.map(([feat, ...vals]) => (
                    <tr key={feat}>
                      <td className="feature-cell">{feat}</td>
                      {vals.map((v, i) => (
                        <td
                          key={i}
                          className={`${v === '—' ? 'muted-cell' : ''} ${
                            i === 1 ? 'featured-cell' : ''
                          }`}
                        >
                          {v}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section membership-faq-section">
        <div className="section-inner">
          <div className="faq-grid">
            <div className="fade-left">
              <div className="sec-eyebrow">FAQ</div>
              <h2 className="sec-title">
                COMMON <span className="acc">QUESTIONS</span>
              </h2>
              <div className="divider" />
              <p className="sec-desc">
                Can&apos;t find what you&apos;re looking for? Our team is available
                to help you choose the right plan and answer your questions.
              </p>

              <button
                className="btn-ghost"
                style={{ marginTop: '2rem' }}
                onClick={() => go('Contact')}
              >
                Contact Us
              </button>
            </div>

            <div className="fade-right">
              {FAQ_DATA.map((f, i) => (
                <div className="faq-item" key={i}>
                  <div
                    className="faq-q"
                    onClick={() => setFaqOpen(faqOpen === i ? null : i)}
                  >
                    <span>{f.q}</span>
                    <span className={`faq-icon${faqOpen === i ? ' open' : ''}`}>
                      +
                    </span>
                  </div>
                  <div className={`faq-a${faqOpen === i ? ' open' : ''}`}>{f.a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="section membership-guarantee-section">
        <div className="section-inner">
          <div className="guarantee-box fade-up">
            <div className="guarantee-icon">🏆</div>
            <h3 className="guarantee-title">THE FITNESS KING GUARANTEE</h3>
            <p className="guarantee-text">
              Join with confidence. We focus on delivering real value, strong
              coaching, and a gym experience that helps you stay committed to your
              goals from day one.
            </p>
            <button
              className="btn-primary"
              style={{ marginTop: '2rem' }}
              onClick={() => go('Contact')}
            >
              Start Your Journey →
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}